import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const CloseIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props} viewBox="0 0 13 13">
    <title>Close</title>
    <polygon points="12.73 9.9 9.19 6.36 12.73 2.83 9.9 0 6.36 3.54 2.83 0 0 2.83 3.54 6.36 0 9.9 2.83 12.73 6.36 9.19 9.9 12.73 12.73 9.9" />
  </IconBase>
);
